import { Box, Stack, Heading, Text, Avatar, HStack } from '@chakra-ui/react'
import { RiLockPasswordFill } from 'react-icons/ri'

type Props = {
    name: string
    label: string
    picture: string
    isCheckedIn: boolean
    lastCheckinCode: string
}

const ChildDetailCard = ({ name, picture, isCheckedIn, lastCheckinCode }: Props) => {
    return (
        <Box w="sm" overflow="hidden" borderWidth="1px" borderRadius="lg" p="6">
            <Text
                color="gray.500"
                fontWeight="semibold"
                letterSpacing="wide"
                fontSize="xs"
                textTransform="uppercase"
            >
                Your child
            </Text>

            <HStack py={4}>
                <Avatar
                    boxSize={'68px'}
                    borderWidth="1px"
                    borderColor="gray.100"
                    name={name}
                    src={picture}
                />
                <Box pl={1}>
                    <Box fontWeight="semibold" as="h4" lineHeight="tight" noOfLines={1}>
                        {name}
                    </Box>
                    <Text lineHeight="25px">
                        {isCheckedIn
                            ? 'checked into the church'
                            : 'checked out of church'}
                    </Text>
                </Box>
            </HStack>
            <Stack spacing={2}>
                <Text
                    color="gray"
                    fontWeight="semibold"
                    letterSpacing="wide"
                    fontSize="xs"
                    textTransform="uppercase"
                >
                    Checkout Code
                </Text>
                <HStack>
                    <RiLockPasswordFill fontSize={'25px'} color={'#6D6AFF'} />
                    <Heading size="sm" color={'brand.200'}>
                        {`${lastCheckinCode ? lastCheckinCode : '- - - - -'}`}
                    </Heading>
                </HStack>
            </Stack>
        </Box>
    )
}

export default ChildDetailCard
